<template>
  <div class="project-detail">
    <img
      src="@/assets/images/project_detail_bg.png"
      alt=""
      class="bg img-fluid"
    />
    <div class="content container px-0">
      <div class="project px-2 px-md-0">
        <h2 class="title">项目信息<span>/Project information</span></h2>
        <div class="info">
          <div class="item">
            <span class="name">项目名称：</span>
            <span class="text">{{ project.projectName }}</span>
          </div>
          <div class="item">
            <span class="name">项目类型：</span>
            <span class="text">{{ project.projectType }}</span>
          </div>
          <div class="item">
            <span class="name">项目预算：</span>
            <span class="text">{{ project.budget }}</span>
          </div>
          <div class="item">
            <span class="name">项目周期：</span>
            <span class="text">{{ project.cycle }}</span>
          </div>
          <div class="item">
            <span class="name">项目描述：</span>
            <span class="text">{{ project.describe }}</span>
          </div>
          <div class="item">
            <span class="name">项目需求：</span>
            <span class="text">{{ project.demand }}</span>
          </div>
        </div>
      </div>
      <div class="demand px-2 px-md-0">
        <h2 class="title">需求方信息<span>/Demand side information</span></h2>
        <div class="info">
          <div class="item">
            <span class="name">联系人：</span>
            <span class="text">{{ demand.name }}</span>
          </div>
          <div class="item">
            <span class="name">联系电话：</span>
            <span class="text">{{ demand.phone }}</span>
          </div>
          <div class="item">
            <span class="name">电子邮箱：</span>
            <span class="text">{{ demand.email }}</span>
          </div>
          <div class="item">
            <span class="name">公司名称：</span>
            <span class="text">{{ demand.companyName }}</span>
          </div>
          <div class="item">
            <span class="name">公司地址：</span>
            <span class="text">{{ demand.address }}</span>
          </div>
        </div>
      </div>
      <button
        class="task-button"
        :class="{ grey: isReceive }"
        @click.stop="showModal"
      >
        {{ receiveBtnText }}
      </button>
    </div>
    <project-contact-modal
      ref="contactModal"
      :name="demand.name"
      :phone="demand.phone"
      :email="demand.email"
      @confirm="confirm"
    ></project-contact-modal>
  </div>
</template>
<style lang="scss" scoped>
.project-detail {
  padding-bottom: 8.5rem;
  .content {
    margin-top: 2.5rem;
    text-align: left;
    position: relative;
    .title {
      font-size: 1.75rem;
      color: #333333;
      text-align: left;
      margin-bottom: 2rem;
      span {
        font-size: 1.5rem;
        color: #999999;
      }
    }
    .item {
      margin-bottom: 0.5rem;
      display: flex;
      .name {
        font-size: 1.25rem;
        color: #999999;
        // vertical-align: top;
      }
      .text {
        flex: 1;
        font-size: 1.25rem;
        color: #333;
      }
    }
    .demand {
      margin-top: 5rem;
    }
    .task-button {
      position: absolute;
      top: -2rem;
      right: 0;
      width: 9.38rem;
      height: 2.38rem;
      font-size: 1.25rem;
      color: white;
      background-color: $acentColor;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
      border: none;
      &.grey {
        background-color: grey;
      }
    }
  }
}
</style>

<script>
import ProjectContactModal from '@/components/ProjectContactModal';
import ApiService from '@/common/api.service';
import { mapGetters } from 'vuex';
import qs from 'qs';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      // project: {
      //   name: 'APP二次开发，增加扫码功能',
      //   type: '软件设计 > APP开发',
      //   price: '10,000 元',
      //   time: '15 个工作日',
      //   desc:
      //     '项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目',
      //   demand:
      //     '项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目描述内容项目'
      // },
      // demand: {
      //   who: '张三',
      //   phone: '18562354893',
      //   email: '18562354893@163.com',
      //   company: '广州市三川田文化科技股份有限公司',
      //   address: '广州市黄埔区国家软件园G栋501'
      // }
      project: {},
      demand: {},
      isReceive: false
    };
  },
  created() {
    this.setAuth(false);
    let data = {
      token: this.token,
      id: this.$route.query.id
    };
    ApiService.post(
      '/orderInterface/getOrderByID.htm',
      qs.stringify(data)
    ).then(data => {
      this.project = data.project;
      this.demand = data.project.user;
      console.log(this.demand);
    });
  },
  computed: {
    receiveBtnText() {
      return this.isReceive ? '已领取' : '领取任务';
    },
    ...mapGetters(['token'])
  },
  components: {
    ProjectContactModal
  },
  methods: {
    showModal() {
      this.$refs.contactModal.show();
    },
    hideModal() {
      this.$refs.contactModal.hide();
    },
    confirm() {
      this.isReceive = true;
    },
    ...mapMutations(['setAuth'])
  }
};
</script>
